import React, { HTMLAttributes, useEffect, useState } from 'react';
import './index.css';
import Icon from '../../basic/icons';
import { useContent } from '../../../providers/content/hook';
import JsonRTE from '../../basic/jsonRTE';
import { AlertProps, alertBannerType, useAlert } from '../../../providers/alert-provider';
import { getSession, setSession } from '../../../utils/sessionStorageUtils';
import { useTranslator } from '../../complex/header/locales-provider';

interface AlertBannerProps extends HTMLAttributes<HTMLDivElement> {
  color?: string;
}
const AlertBanner = ({ color = '' }: AlertBannerProps): JSX.Element | null => {
const { service } = useContent();
const [alertContent, setAlertContent] = useState<any>();
const { alertType, setAlertType } = useAlert() as AlertProps;
const locales = useTranslator('global');

  useEffect(() => {
    if (!service) return;
    if (alertType == alertBannerType.A2_PROFILE_ERROR &&  getSession(alertBannerType.A2_PROFILE_ERROR) == 'true') return;
    const fetchContent = async () => {
      if (alertType) {
        const printPageData = await service?.getAlertBaner(alertType);
        setAlertContent(printPageData);
      }
    };
    fetchContent();
  }, [alertType]);

  const closeAlert = (e: any) => {
    e.preventDefault();
    setAlertContent(null);
    setAlertType('');
    setSession(alertType, 'true');
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {  
      closeAlert(e);
    }
  }

  const bannerColor = color != '' ? color : 'bg-primary-100';
  if (alertContent) {
    return (
      <div
        data-testid="alertMainDiv"
        className={`${bannerColor} rounded flex justify-around items-center`}
      >
        <div data-testid="alertChildDiv" className="flex p-4 base rounded  items-center">
          <Icon name="warning" className="text-6xl sm:text-2xl mr-2 sm:mr-3" />

          <div className='inline sm:block'>
          <p data-testid="alertLabel" className="text-sm font-medium mr-2 inline sm:block">
            {alertContent?.header}
          </p>
          <JsonRTE
            json={alertContent?.message}
            className="text-sm inline sm:block"
            linkClassName="text-secondary-400 font-medium text-left"
          />
          </div>
        </div>
        <Icon name="close" className="text-6xl sm:text-2xl mr-3 sm:mr-1 cursor-pointer" onKeyDown={e => handleKeyDown(e)} onClick={e => closeAlert(e)}
          tabIndex={0} role='button' aria-hidden="false" aria-label={alertType === alertBannerType.USER_LOGIN_ERROR ? (locales?.['aria-label.close.login.alert'] || '') : `Close ${alertContent?.header}`} />
      </div>
    );
  } else {
    return null;
  }
};

export default AlertBanner;
